/**
 * Copyright (C) 2021 Tencent.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default {
  bold: 'Жирный',
  code: 'Код',
  graph: 'График',
  h1: 'Заголовок 1',
  h2: 'Заголовок 2',
  h3: 'Заголовок 3',
  h4: 'Заголовок 4',
  h5: 'Заголовок 5',
  header: 'Заголовок',
  insert: 'Вставить',
  italic: 'Курсив',
  list: 'Лист',
  quickTable: 'Quick Table',
  quote: 'Цитата',
  size: 'Размер',
  color: 'Цвет текста и фон',
  strikethrough: 'Зачеркнуто',
  sub: 'Sub',
  sup: 'Sup',
  togglePreview: 'Переключение предварительного просмотра',
  fullScreen: 'Полноэкранный режим',
  image: 'Изображение',
  audio: 'Аудио',
  video: 'Видео',
  link: 'Ссылка',
  hr: 'Горизонтальная линия',
  br: 'Новая строка',
  toc: 'Таблица содержания',
  pdf: 'PDF',
  word: 'Word',
  table: 'Таблица',
  'line-table': 'линия таблица',
  'bar-table': 'бар стол',
  'radar-table': 'радарный стол',
  'map-table': 'таблица карты',
  lineTable: 'линия таблица',
  barTable: 'бар стол',
  radarTable: 'радарный стол',
  mapTable: 'таблица карты',
  heatmapTable: 'таблица тепловой карты',
  sankeyTable: 'Диаграмма Санки',
  pieTable: 'стол для пирога',
  proTable: 'диаграмма',
  formula: 'Формула',
  insertFormula: 'Вставить формулу',
  insertFlow: 'Вставить поток',
  insertSeq: 'Вставить Seq',
  insertState: 'Вставить State',
  insertClass: 'Вставить класс',
  insertPie: 'Вставить Pie',
  scatterTable: 'таблица рассеяния',
  insertGantt: 'Вставить Gantt',
  checklist: 'Контрольный список',
  ol: 'Упорядоченный список',
  ul: 'Неупорядоченный список',
  undo: 'Отменить',
  redo: 'Переделывать',
  previewClose: 'Предварительный просмотр закрыт',
  codeTheme: 'Тема для кода',
  switchModel: 'Модель переключателя',
  switchPreview: 'Переключите предварительный просмотр',
  switchEdit: 'Переключить редактирование',
  classicBr: 'Классическая новая линия',
  normalBr: 'Обычная новая строка',
  settings: 'Настройки',
  mobilePreview: 'Предварительный просмотр на мобильном устройстве',
  copy: 'Копировать',
  export: 'Экспорт',
  underline: 'Подчеркивать',
  pinyin: 'Pinyin',
  pastePlain: 'Вставить в виде обычного текста',
  pasteMarkdown: 'Вставить как Markdown',
  hide: 'Скрыть панель инструментов',
  exportToPdf: 'Экспорт в формат PDF',
  exportScreenshot: 'Скриншот',
  exportMarkdownFile: 'Экспорт файла Markdown',
  exportHTMLFile: 'Экспорт предварительного просмотра HTML-файла',
  exportWordFile: 'Экспорт в Word',
  panel: 'Панель',
  detail: 'Аккордеон',
  heading1: 'H1 Заголовок',
  heading2: 'H2 Заголовок',
  heading3: 'H3 Заголовок',
  complement: 'Дополнение',
  summary: 'Резюме',
  justify: 'объяснить',
  justifyLeft: 'Слева',
  justifyCenter: 'Центр',
  justifyRight: 'Справа',
  align: 'Выравнивание',
  alignLeft: 'Выровнять слева',
  alignCenter: 'В центре',
  alignRight: 'Выровнять вправо',
  alignJustify: 'Выровнять концы',
  alignFloatLeft: 'Выровнять вправо',
  alignFloatRight: 'Выровнять слева',
  publish: 'Публиковать',
  colorPickerText: 'Текст',
  colorPickerBackground: 'Фон',
  colorPickerClear: 'Очистить цвет',
  colorPickerRecentColors: 'Недавние цвета',
  colorPickerPresetColors: 'Предустановленные цвета',
  small: 'Маленький',
  medium: 'Средний',
  large: 'Большой',
  superLarge: 'Очень большой',
  detailDefaultContent:
    'Нажмите, чтобы развернуть подробнее\nСодержание\n++- Развернуть по умолчанию\nСодержание\n++ Свернуть по умолчанию\nСодержание',
  inlineCode: 'Встроенный код',
  codeBlock: 'Кодовый блок',
  inlineMath: 'Встроенная формула',
  mathBlock: 'Блочная формула',
  shortcutKeySetting: 'Настройки горячих клавиш',
  editShortcutKeyConfigTip: 'Дважды щёлкните или нажмите Редактировать, чтобы изменить сочетание клавиш.',
  editingShortcutKeyConfigTip: 'Нажмите Enter для сохранения, Backspace для удаления добавленной клавиши',
  staticShortcutTip: 'Встроенные сочетания клавиш нельзя изменить',
  disabledShortcutTip: 'Сочетания клавиш в настоящее время отключены',
  cursorPosition: 'Позиция курсора',
  wordCount: 'Количество слов',
  wordCountP: 'P',
  wordCountW: 'W',
  wordCountC: 'C',
  wordCountL: 'L',
  wordCountImg: 'Изображение',
  wordCountCode: 'Код',
  wordCountChinese: 'Китайский',
  wordCountEnglish: 'Русский',
  wordCountNumber: 'Число',
  wordCountSymbol: 'Символ',
  deleteColumn: 'Удалить столбец',
  deleteRow: 'Удалить строку',
  addRow: 'Добавить строку',
  addCol: 'Добавить столбец',
  moveRow: 'Переместить строку',
  moveCol: 'Переместить столбец',
  shortcutStaticTitle: 'Следующие сочетания клавиш не могут быть изменены',
  shortcutStatic1: 'Отступить всю строку влево',
  shortcutStatic2: 'Отступить всю строку вправо',
  shortcutStatic3: 'Скопировать и вставить строку',
  shortcutStatic4: 'Вставить пустую строку ниже',
  shortcutStatic5: 'Вставить пустую строку выше',
  shortcutStatic6: 'Поменять с предыдущей строкой',
  shortcutStatic7: 'Поменять с следующей строкой',
  shortcutStatic8: 'Удалить строку',
  shortcutStatic9: 'Выделить влево по слову',
  shortcutStatic10: 'Выделить вправо по слову',
  shortcutStatic11: 'Удалить по слову',
  shortcutStatic12: 'Выделить содержимое внутри скобок',
  shortcutStatic13: 'Вставить несколько курсоров',
  shortcutStatic14: 'Выделить каждую строку текстового блока отдельно',
  shortcutStatic15: 'Найти',
  shortcutStatic16: 'Выделить все вхождения слова',
  shortcutStatic17: 'Отменить',
  shortcutStatic18: 'Вернуть отмену',
  leftMouseButton: 'левая кнопка мыши',
  disableShortcut: 'Отключить все горячие клавиши',
  enableShortcut: 'Включить горячие клавиши',
  recoverShortcut: 'Восстановить конфигурацию по умолчанию',
  search: 'Поиск/Заменить',
  autoWrap: 'Автоперенос строк',
  footnoteTitle: 'Сноска',
  searchFor: 'Найти',
  replaceWith: 'Заменить на',
  previousMatch: 'Предыдущее',
  nextMatch: 'Следующее',
  replace: 'Заменить',
  replaceAll: 'Заменить всё',
  regExpSearch: 'Регулярное выражение',
  caseSensitiveSearch: 'С учётом регистра',
  wholeWordSearch: 'Целое слово',
  matchesFoundText: 'совпадений найдено.',
  toggleReplace: 'Показать замену',
  close: 'Закрыть',
  border: 'Рамка',
  shadow: 'Тень',
  radius: 'Скругление',
  customShortcut: 'Пользовательские горячие клавиши',
  staticShortcut: 'Встроенные горячие клавиши',
  edit: 'Редактировать',
  save: 'Сохранить',
  cancel: 'Отмена',
  saveAsImage: 'Сохранить как изображение',
  mapChartLoading: 'Загрузка данных карты',
  mapChartLoadingTip: 'Если загрузка занимает много времени, пожалуйста, проверьте подключение к интернету',
  mapChartError: 'Ошибка загрузки данных карты',
  mapChartErrorTip: 'Пожалуйста, проверьте источник данных или подключение к интернету',
  mapChartRetry: 'Нажмите, чтобы перезагрузить',
  chartRenderError: 'Ошибка рендеринга графика',
  chartLibraryNotLoadedTip: 'Библиотека ECharts не загружена',
  radarData: 'Данные радара',
  scatterData: 'Данные скаттера',
  pieData: 'Распределение данных',
  heatmapData: 'Данные тепловой карты',
  mapData: 'Картографические данные',
  maxValue: 'Максимальное значение',
  minValue: 'Минимальное значение',
  high: 'Высокий',
  low: 'Низкий',
  mermaidSource: 'Исходный код',
  mermaidPreview: 'Просмотр',
};
